import { radar } from '@/common/log';
import { useEffect, useRef } from 'react';
import { Platform } from 'react-native';

export function usePerfLog(firstLoading: boolean) {
    const startTimeRef = useRef(Date.now());
    const initTimeRef = useRef(Date.now());
    useEffect(() => {
        if (!firstLoading) {
            if (startTimeRef.current) {
                radar.event({
                    name: 'SHOP_KRN_PERT_LOG',
                    params: {
                        page: 'Detail',
                        stage: 'firstRender',
                        cost: Date.now() - startTimeRef.current,
                        os: Platform.OS,
                    },
                });
                radar.event({
                    name: 'SHOP_KRN_PERT_LOG',
                    params: {
                        page: 'Detail',
                        stage: 'firstTotalRender',
                        cost: Date.now() - initTimeRef.current,
                        os: Platform.OS,
                    },
                });
                console.log('perf::firstRender cost:::', Date.now() - startTimeRef.current, Date.now() - initTimeRef.current);
                startTimeRef.current = 0; // 仅上报一次
            }
        }
    }, [firstLoading]);
    function sendItemInfoApiLog() {
        if (startTimeRef.current) {
            radar.event({
                name: 'SHOP_KRN_PERT_LOG',
                params: {
                    page: 'Detail',
                    stage: 'itemInfoApi',
                    cost: Date.now() - startTimeRef.current,
                    os: Platform.OS,
                },
            });
            console.log('perf::itemInfoApi cost:::', Date.now() - startTimeRef.current);
            startTimeRef.current = Date.now();
        }
    }
    return {
        sendItemInfoApiLog,
        resetStartTime: () => (startTimeRef.current = Date.now()),
    };
}
